import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IvrModel } from './ivr.model';
import { Msisdn } from '../shared/msisdn/msisdns';
import { Observable } from 'rxjs';
import { LimitsExceededResponse } from '../lead-generation/shared/domain/LimitsExceededResponse';
import { map } from 'rxjs/operators';

@Injectable()
export class IvrService {
  constructor(private http: HttpClient) {}

  getIvrs() {
    return this.http.get<IvrModel[]>('/ivr');
  }

  getIvr(id: string) {
    return this.http.get<IvrModel>(`/ivr/${id}`);
  }

  createIvr(data: IvrModel) {
    return this.http.post<IvrModel>('/ivr', data);
  }

  updateIvr(id: string, data: IvrModel) {
    return this.http.put<IvrModel>(`/ivr/${id}`, data);
  }

  removeIvr(id: string) {
    return this.http.delete(`/ivr/${id}`);
  }

  getMsisdnsAssignedToIvr(ivrId: string) {
    return this.http.get<Msisdn[]>(`/ivr/${ivrId}/msisdns`);
  }

  assignIvrToNumber(msisdnId: string, ivrId: string) {
    return this.http.post<IvrModel>(`/inbound/configuration/numbers/${msisdnId}/ivr/${ivrId}`, {});
  }

  checkIfLimitsExceeded(): Observable<boolean> {
    return this.http.get<LimitsExceededResponse>('/ivr/limits-exceeded').pipe(map(response => response.limitsExceeded));
  }

  unassignIvrToNumber(msisdnId: string) {
    return this.http.delete<IvrModel>(`/inbound/configuration/numbers/${msisdnId}/ivr`, {});
  }
}
